export const LOADER_TIMEOUT = 8000;
export const RETRY_TIMEOUT = 5000;
export const DEBOUNCE_TIMEOUT = 500;
